import { css } from '@emotion/react';

export const baseStyles = css`
  @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Poppins:300,400,500,600&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-display: swap;
  }

  .gatsby-resp-image-wrapper > a {
    position: relative;
    display: block;
  }

  ::-webkit-input-placeholder {
    /* Edge */
    color: #c2c2c2;
  }

  :-ms-input-placeholder {
    /* Internet Explorer */
    color: #c2c2c2;
  }

  img {
    box-shadow: none !important;
  }

  ::placeholder {
    color: #c2c2c2;
  }

  html {
    background-color: var(--base-background);
  }

  html,
  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Roboto Light', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';

    font-size: 16px;
    scroll-behavior: smooth;
  }

  a {
    transition: color 0.15s;
    /* color: #663399; */
  }

  body {
    font-family: 'Roboto';
  }

  .visibleMobile {
    display: none;
  }

  .visibleMobileView {
    display: none !important;
  }

  .video-responsive {
    position: relative;
    padding-bottom: 56.2%;
  }

  a {
    text-decoration: none;
  }

  a:hover {
    text-decoration: none;
  }

  .displayInline {
    display: inline-block;
  }

  .navBarToggle {
    border-radius: 4px;
    width: 36px;
    height: 33px;
    position: absolute;
    right: 20px;
    padding: 8px 5px;
    display: none;
  }

  .navBarToggle .iconBar {
    display: block;
    width: 22px;
    height: 2px;
    border-radius: 1px;
    margin: 4px auto 0;
    background-color: var(--button-font);
  }

  .navBarToggle .iconBar:first-child {
    margin-top: 0px;
  }

  .video-responsive iframe {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .diffNewLine {
    color: #22863a;
    background-color: #f0fff4;
  }

  .diffRemoveLine {
    color: red;
    background-color: #ffcccc;
  }

  .navBarParent {
    width: 100%;
    float: left;
    display: flex;
    align-items: center;
  }

  .divider {
    height: 30px;
    margin: 0 15px;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  .navBarULRight {
  }

  .githubIcon {
    width: 15px;
    margin-right: 5px;
  }

  .githubSection {
    display: flex;
    align-items: center;
    color: #000;
    opacity: 0.7;
  }

  .githubSection:hover {
    text-decoration: none;
    opacity: 1;
  }

  .navbar-default .navbar-toggle .icon-bar {
    background-color: #fff !important;
  }

  .navbar-default .navbar-toggle:focus,
  .navbar-default .navbar-toggle:hover {
    background-color: #001933;
  }

  .headerWrapper {
    border-bottom: 1px solid rgb(212, 218, 223);
    box-shadow: rgba(116, 129, 141, 0.1) 0px 1px 1px 0px;
    display: flex;
    align-items: center;
  }

  .formElement {
    background-color: transparent;
    padding: 4px;
    border-radius: 5px;
    position: relative;
  }

  .formElement:focus {
    outline: none;
    border: none;
  }

  .formElement svg path {
    fill: #2fd2c5;
  }

  #homeBoy {
    color: var(--info-foreground);
  }

  .headerTitle {
    height: auto;
    font-size: 2rem;
    line-height: 1.5;
    font-weight: 300;
    color: var(--info-foreground) !important;
    text-transform: uppercase;
  }

  .headerTitle a {
    color: #fff;
  }

  .headerTitle a:hover {
    text-decoration: none;
    opacity: 0.8;
  }

  .logoWrapper {
    padding: 21px 0;
    padding-left: 20px;
  }

  .logoContent {
    font-family: 'Roboto';
    margin-left: 16px;
    font-size: 28px;
    line-height: 1.5;
    font-weight: 500;
    padding-right: 10px;
  }

  /* Header section starts here */

  .removePadd {
    padding: 0 !important;
  }

  .navBarDefault {
    background-color: var(--header-color);
    border-radius: 0;
    margin-bottom: 0;
    border-width: 0;
    display: flex;
    align-items: center;
    z-index: 1;
    padding: 15px;
    position: relative;
    height: 80px;
  }

  .navBarHeader {
    min-width: 335px;
    padding-right: 20px;
    display: flex;
    align-items: center;
  }

  .navBarBrand {
    padding: 0px 0px;
    display: flex;
    align-items: center;
  }

  .navBarBrand img {
    width: 50px;
    margin-right: 1.5rem;
    display: inline-block;
  }

  .navBarUL li {
    list-style-type: none;
  }

  .navBarUL {
    -webkit-overflow-scrolling: touch;
  }

  .navBarUL li a {
    font-family: 'Roboto';
    color: #fff !important;
    font-size: 16px;
    font-weight: 500;
    line-height: 1em;
    opacity: 1;
    padding: 10px 15px;
  }

  .navBarNav {
    display: flex;
    align-items: center;
  }

  .navBarUL li a img,
  .navBarUL li a .shareIcon {
    width: 20px;
  }

  .navBarUL li a:hover {
    opacity: 0.7;
  }

  pre {
    border: 0 !important;
    background-color: rgb(245, 247, 249); /* !important; */
  }

  blockquote {
    color: var(--comments);
    margin: 0px 0px 24px;
    padding: 0px 0px 0px 12px;
    border-left: 4px solid var(--border-color);
    border-color: var(--border-color);
  }

  details {
    border-left: 4px solid var(--border-color);
    padding-left: 1rem;
  }

  .socialWrapper {
    display: flex;
    align-items: center;
  }

  .socialWrapper li {
    display: inline-block;
  }

  .socialWrapper li a {
    display: contents;
  }

  .discordBtn, .twitterBtn {
    border-radius: 4px;
    border: solid 1px #d1d2d3;
    background-color: #f1f5f8;
    width: 20px;
    height: 20px;
    padding-top: 2px;
    margin-left: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: .8;
    cursor: pointer;
  }

  .twitterBtn img {
    width: 12px !important;
  }

  .discordBtn img {
    width: 10px !important;
  }

  .discordBtn:hover, .twitterBtn:hover {
    opacity: 1;
  }

  .discordBtn {
    img {
      width: 10px;
    }
  }

  /* Header section ends here */

  .sidebarTitle {
    background-color: var(--secondary-background);
    padding: 18px 16px;
    font-family: 'Poppins';
    font-size: 18px;
    font-weight: 600;
    color: var(--info-foreground);
    display: flex;
    align-items: center;
  }

  .sideBarShow {
    display: none;
  }

  .sidebarTitle a {
    color: #001934;
  }

  .headerNav {
    font-family: 'Roboto';
    padding: 0px 24px;
    color: #001933;
    font-size: 16px;
    font-weight: 500;
    line-height: 1em;
  }

  .headerNav a {
    color: #001933;
    text-decoration: none;
  }

  .headerNav a:hover {
    text-decoration: none;
  }

  .logoWrapper img {
    width: 40px;
  }

  .sideBarUL {
    margin-top: 32px;
  }

  .sideBarUL li {
    list-style-type: none;
    width: auto;
  }

  .sideBarUL li a {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
    padding: 7px 24px 7px 16px;
    padding-left: 10px;
    padding-right: 25px;
    border-style: solid none solid solid;
    border-width: 1px 0px 1px 1px;
    border-color: transparent var(--border-color) transparent transparent;
  }

  .hideFrontLine .collapser {
    background: transparent;
    border: none;
    outline: none;
    position: absolute;
    right: 20px;
    z-index: 1;
    cursor: pointer;
  }

  a,
  a:visited {
    position: relative;
    color: var(--accent-color);
    text-decoration: none;
  }

  p > a:hover::after,
  div > ul > li > a:hover::after,
 details > ul > li > a:hover::after

  {
    transform: scale(1);
  }

  p > a::after,
  div > ul > li > a::after,
  details > ul > li > a::after
  {
    content: "";
    position: absolute;
    width: 98%;
    height: 2px;
    bottom: -5px;
    left: 0px;
    background: var(--accent-color);
    transition: transform 0.3s ease 0s;
    transform: scale(0);
  }


  .hideFrontLine .active > a {
    background-color: var(--selection-background);
    color: var(--selection-foreground) !important;
  }

  .firstLevel ul li .collapser svg path {
    fill: var(--base-icon-color) !important;
  }

  .active .collapser > svg > path {
    fill: #001933 !important;
  }

  .firstLevel ul .item ul .item {
    border-left: 1px solid var(--border-color);
  }

  .sideBarUL .item {
    list-style: none;
    padding: 0;
  }

  .sideBarUL .item > a {
    color: var(--accent-color);
    text-decoration: none;
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    padding-right: 35px;
    padding-left: 15px;
  }

  .showFrontLine .item > a:hover {
    background-color: #001933;
  }

  .showFrontLine .active > a {
    background-color: #001933;
  }

  .sideBarUL .item .item {
    margin-left: 16px;
  }

  .firstLevel > ul > .item {
    margin-left: 0 !important;
  }

  ::-moz-selection {
    background: var(--selection-background);
    color: var(--selection-foreground);
  }

  ::selection {
    background: var(--selection-background);
    color: var(--selection-foreground);
  }

  .showFrontLine .item .item {
    border-left: 1px solid var(--border-color);
    border-left-color: var(--border-color);
    padding: 0;
    width: calc(100% - 16px) !important;
  }

  .showFrontLine .item .active > a {
    border-color: var(--border-color) !important;
    border-style: solid none solid solid;
    border-width: 1px 0px 1px 1px;
    background-color: var(--selection-background) !important;
    color: var(--selection-foreground);
  }

  .titleWrapper {
    display: flex;
    align-items: center;
    padding-bottom: 40px;
    border-bottom: 1px solid var(--border-color);
    margin-bottom: 32px;
  }

  .gitBtn {
    height: 30px;
    min-height: 30px;
    display: flex;
    align-items: center;
  }

  .gitBtn img {
    width: 15px;
    display: inline-block;
    margin-right: 5px;
  }

  .addPaddTopBottom {
    padding: 50px 0;
  }

  .preRightWrapper {
    display: block;
    margin: 0px;
    flex: 1 1 0%;
    padding: 16px;
    text-align: right;
  }

  .smallContent {
    display: block;
    margin: 0px;
    padding: 0px;
    color: var(--info-foreground);
  }

  summary {
    color: var(--info-foreground);
  }


  .smallContent span {
    font-size: 12px;
    line-height: 1.625;
    font-weight: 400;
  }

  /* **************************** */

  .nextRightWrapper {
    display: block;
    margin: 0px;
    padding: 16px;
    flex: 1 1 0%;
  }

  /* tables.css */

  table {
    padding: 0;
  }

  table tr {
    border-top: 1px solid var(--border-color);
    margin: 0;
    padding: 0;
  }

  table tr:nth-child(2n) {
    background-color: #f8f8f8;
  }

  table tr th {
    font-weight: bold;
    border: 1px solid var(--border-color);
    text-align: left;
    margin: 0;
    padding: 6px 13px;
  }

  table tr td {
    border: 1px solid var(--border-color);
    text-align: left;
    margin: 0;
    padding: 6px 13px;
  }

  table tr th :first-child,
  table tr td :first-child {
    margin-top: 0;
  }

  table tr th :last-child,
  table tr td :last-child {
    margin-bottom: 0;
  }

  /* end - tables.css */

  /* Image styling */

  img {
    max-width: 100%;
  }

  /* end image */

  .githubBtn {
    display: flex;
    align-items: center;
    font-size: 16px;
    padding: 10px 0px;
    padding-left: 15px;
    max-height: 40px;
  }

  .githubBtn span span {
    display: flex;
    align-items: center;
  }

  .communitySection {
    font-size: 24px;
    font-weight: 700;
  }

  .authorSection {
    padding: 20px 0;
  }

  .authorSection,
  .authorName {
    display: flex;
    align-items: center;
  }

  .authorImg img {
    width: 75px;
    height: 75px;
    border-radius: 50%;
    min-width: 75px;
    max-width: 75px;
    min-height: 75px;
    max-height: 75px;
  }

  .authorDetails {
    padding-left: 10px;
  }

  .authorDesc {
    padding-top: 5px;
    font-size: 14px;
  }

  .authorName img {
    margin-left: 10px;
    display: inline-block;
    width: 20px;
  }

  .authorName img:hover {
    opacity: 0.7;
  }

  .heading1 {
    font-size: 26px;
    font-weight: 800;
    line-height: 1.5;
    margin-bottom: 16px;
    margin-top: 32px;
  }

  .heading2 {
    font-size: 24px;
    font-weight: 700;
    line-height: 1.5;
    margin-bottom: 16px;
    margin-top: 32px;
  }

  .heading3 {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.5;
    margin-bottom: 16px;
    margin-top: 32px;
  }

  .heading4 {
    font-size: 18px;
    font-weight: 500;
    line-height: 1.5;
    margin-bottom: 16px;
    margin-top: 32px;
  }

  .heading5 {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    margin-bottom: 16px;
    margin-top: 32px;
  }

  .heading6 {
    font-size: 14px;
    font-weight: 300;
    line-height: 1.5;
    margin-bottom: 16px;
    margin-top: 32px;
  }

  .paragraph {
    margin: 16px 0px 32px;
    line-height: 1.625;
  }

  .pre {
    font-size: 14px;
    margin: 0px;
    padding: 16px;
    overflow: auto;
  }

  .poweredBy {
    font-size: 0.6em;
    text-align: end;
    padding: 0;
  }

  .topnav {
    -webkit-transition: top 0.5s, bottom 0.5s;
  }

  @media (max-width: 767px) {
    .formElement svg path {
      fill: #001934;
    }

    .visibleMobileView {
      display: block !important;
    }

    .responsive {
      margin-top: 15px;
      position: relative;
      padding-bottom: 20px;
      border-top: 1px solid var(--border-color);
    }

    hr {
      color: var(--border-color);
      background-color: var(--border-color);
      border-top: 1px solid var(--border-color);
    }

    .headerTitle {
      padding-right: 50px;
      font-size: 16px;
    }

    .navBarBrand {
      min-height: 40px;
    }

    .navBarBrand img {
      margin-right: 8px;
    }

    .topnav.responsive .visibleMobile {
      display: block;
    }

    .topnav .navBarUL {
      display: none;
    }

    .topnav.responsive .navBarUL {
      display: block;
      text-align: left;
    }

    .hiddenMobile {
      display: none !important;
    }

    hr {
      margin-top: 0;
      margin-bottom: 0;
    }

    .navBarParent {
      display: block;
    }

    .separator {
      margin-top: 20px;
      margin-bottom: 20px;
    }

    .navBarULRight {
      position: static;
    }

    .navBarUL {
      display: flex;
      align-items: center;
      margin: 7.5px 0px;
    }

    .navBarUL li {
      height: 37px;
    }

    .navBarUL li a {
      font-size: 14px;
      padding: 10px 15px;
    }

    .navBarDefault {
      display: block;
      height: auto;
    }

    .navBarToggle {
      margin-right: 0;
      display: block;
      position: absolute;
      left: 11px;
      top: 15px;
      background: var(--button-color);
    }

    .navBarHeader {
      display: flex;
      min-width: auto;
      padding-right: 0;
      align-items: center;
    }

    .navBarBrand {
      font-size: 20px;
      padding: 0 0;
      padding-left: 0;
      flex: initial;
      padding-right: 15px;
    }

    .titleWrapper {
      padding: 0 15px;
      display: block;
    }

    .gitBtn {
      display: inline-block;
    }

    .mobileView {
      text-align: left !important;
      padding-left: 0 !important;
    }

  }

  @media (min-width: 768px) and (max-width: 991px) {
    .navBarDefault {
      padding: 10px;
    }

    .navBarBrand {
      font-size: 22px;
    }

    .navBarHeader {
      min-width: 240px;
      flex: initial;
    }

    .githubBtn {
      padding: 10px 10px;
    }

    .divider {
      margin: 0 5px;
      height: 20px;
    }

    .navBarUL li a {
      padding: 10px 5px;
    }

  }
`;
